import BooleanFilter from "@search/store/filters/primitive/BooleanFilter";

class FourBallFilter extends BooleanFilter {
  constructor(value: boolean) {
    super({
      defaultValue: false,
      label: "4-Ball",
      name: "fourBall",
      value,
    });
  }
}

export default FourBallFilter;
export { FourBallFilter };
